import apiClient from './axiosClient';

const getPlacesSearchRequest = async (input: string) => {
  return apiClient.get(`places/${input}`).then((res) => res.data);
};

export default getPlacesSearchRequest;
